import { render } from "./userSerial.vue?vue&type=template&id=8ff00d4e&scoped=true"
import script from "./userSerial.vue?vue&type=script&lang=js"
export * from "./userSerial.vue?vue&type=script&lang=js"

import "./userSerial.vue?vue&type=style&index=0&id=8ff00d4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8ff00d4e"

export default script